import type { FC } from "react";
import type { TextInputKeyPressEvent } from "react-native";
import { View } from "react-native";
import { StyleSheet, useUnistyles } from "react-native-unistyles";
import "../../../theme";
import { Icon } from "../../Icon";
import { Input } from "../../Input";

interface CountrySearchFieldProps {
  readonly value: string;
  readonly onChangeText: (text: string) => void;
  readonly autoFocus: boolean;
  readonly onKeyPress?: ((e: TextInputKeyPressEvent) => void) | undefined;
}

const CountrySearchField: FC<CountrySearchFieldProps> = ({ value, onChangeText, autoFocus, onKeyPress }) => {
  const { theme } = useUnistyles();
  return (
    <Input
      value={value}
      onChangeText={onChangeText}
      onKeyPress={onKeyPress}
      placeholder="Search country or code"
      clearable
      clearAccessibilityLabel="Clear search"
      leftContent={
        <View style={styles.icon}>
          <Icon name="search" size={16} color={theme.colors.textMuted} />
        </View>
      }
      textInputProps={{
        accessibilityLabel: "Search countries",
        autoFocus,
        autoCorrect: false,
        autoCapitalize: "none",
        returnKeyType: "search",
      }}
    />
  );
};

CountrySearchField.displayName = "CountrySearchField";

export { CountrySearchField };

const styles = StyleSheet.create((theme) => ({
  icon: {
    paddingLeft: theme.spacing["3xl"],
  },
}));
